import { DeleteIcon, EditIcon, SearchIcon } from '@chakra-ui/icons';
import { Avatar, Box, Button, Flex, FormControl, FormHelperText, FormLabel, Heading, HStack, IconButton, Input, Link, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Spacer, Spinner, Stack, Tab, Table, TableCaption, TableContainer, TabList, TabPanel, TabPanels, Tabs, Tag, Tbody, Td, Text, Textarea, Th, Thead, Tr, useDisclosure, VStack } from '@chakra-ui/react'
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { BiSort } from 'react-icons/bi';
import { FiPlus } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import colors from '../../../../Utils/colors';
import TextHelper from '../../../../Utils/TextHelper';
import { IoLogoWhatsapp } from "react-icons/io"
import { addDoc, collection, doc, getDoc, getDocs, limit, query, setDoc } from 'firebase/firestore';
import { auth, db } from '../../../../Configs/firebase';
import Loader from '../../../../Routes/hooks/useLoader';

const defaultTemplate = {
  title: "",
  template: ""
}

function TableUser({ data, EditDataComponent, handleDelete }) {
  const [filter, setFilter] = useState("")
  const [dataFilter, setDataFilter] = useState([])
  const [dataSort, setDataSort] = useState(dataFilter)
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [whatsappDataTemplate, setWhatsappDataTemplate] = useState([])
  const [whatsappTemplate, setWhatsappTemplate] = useState(defaultTemplate)
  const [titleTable, setTitleTable] = useState([
    { title: "index", filter: false },
    { title: "Name", filter: false },
    { title: "User ID", filter: false },
    { title: "Email", filter: false },
    { title: "Actions", filter: false },
    { title: "Whatsapp Message", filter: true }
  ]);

  const navigate = useNavigate()


  const getData = () => {
    console.log(data, 'yyyy')
    const dataArr = data
    console.log(filter, 'filter')
    const filterData = dataArr.filter((x) => x.role === filter)
    if (filter === "") {
      setDataFilter(dataArr)
      console.log("gaada")
    } else {
      setDataFilter(filterData)
      console.log('ada')
    }
  }


  useEffect(() => {
    getData()

    return () => {
      setDataFilter([])
    }
  }, [filter])



  const fetchDataWahatsappTemplate = () => {
    const q = query(collection(db, "templatewhatsapp"), limit(100));
    getDocs(q).then(res => {
      const dataTemp = []
      res.forEach(item => {
        dataTemp.push({ ...item.data(), id: item.id })
      })
      setWhatsappDataTemplate(dataTemp)
    }).catch(e => console.log(e))
  }




  const sortBy = (key) => {
    const temp = titleTable;

    // set tiap data title mempunyai angka key
    const index = temp.findIndex((data) => data.title === key);

    // ini di jadiin angka terus ngerubah filter true false
    for (let i = 0; i < titleTable.length; i++) {
      if (index === i) {
        temp[i] = {
          title: titleTable[i].title,
          filter: !titleTable[i].filter,
        };
      } else {
        temp[i] = {
          title: titleTable[i].title,
          filter: false,
        };
      }
    }
    setTitleTable(temp)
    // memasang switch case filter
    switch (index) {

      case 1:
        if (titleTable[index].filter) {
          return setDataSort([
            ...dataFilter.sort((a, b) => b.name.localeCompare(a.name)),
          ]);
        }
        return setDataSort([
          ...dataFilter.sort((a, b) => a.name.localeCompare(b.name)),
        ]);

      case 3:
        if (titleTable[index].filter) {
          return setDataSort([
            ...dataFilter.sort((a, b) => b.email.localeCompare(a.email)),
          ]);
        }
        return setDataSort([
          ...dataFilter.sort((a, b) => a.email.localeCompare(b.email)),
        ]);
      default:
        return null
    }
  }
  const onSelectChangeTemplate = (e) => {
    console.log(e.target.value)
    const find = whatsappDataTemplate.find(res => res.id === e.target.value)
    setWhatsappTemplate(find)
  }

  const whatsAppClickMessage = (phone, name) => {
    auth.onAuthStateChanged(user => {
      let changePhone = ""
      if (phone[0] === "0") {
        changePhone = `62${phone.slice(1, phone.length)}`
      }
      // eslint-disable-next-line no-template-curly-in-string
      const decode = decodeURI(whatsappTemplate.template)
      const changeName = decode.replace('${name}', String(name).toLowerCase()).replace("${admin}", user.displayName)

      window.open(`https://api.whatsapp.com/send/?phone=${changePhone}&text=${encodeURI(changeName)}&type=phone_number&app_absent=0`);
    })
  }



  return (
    <Box>
      <ModalWhatsAppTemplate isOpen={isOpen} onClose={onClose} onOpen={onOpen} />
      <HStack m={10}>
        <Box>
          <Heading size="lg">
            Users Admin
          </Heading>
        </Box>
        <Spacer />
        <HStack>
          <Box>
            <Button justifyContent="flex-end" onClick={onOpen}>
              <HStack>
                <FiPlus />
                <Text>WhatsApp Template</Text>
              </HStack>
            </Button>
          </Box>
          <Box>
            <Button justifyContent="flex-end" onClick={() => navigate('/admin/users/add-new-member')}>
              <HStack>
                <FiPlus />
                <Text>New Account</Text>
              </HStack>
            </Button>
          </Box>

          <Select placeholder='Filter by' onChange={(e) => setFilter(e.target.value)}>
            <option value='admin'>Admin</option>
            <option value='member'>Member</option>
            <option value='user'>User</option>
          </Select>
        </HStack>
      </HStack>
      <TableContainer mx={10}>
        <Table variant="simple">
          <Thead bgColor={colors.theme}>
            <Tr>
              {titleTable.map((x) => (
                <Th>
                  <Button
                    key={x.title}
                    variant="ghost"
                    onClick={() => sortBy(x.title)}
                  >
                    <HStack spacing="1">
                      <Text color={colors.black}>{x.title}</Text>
                      <BiSort fontWeight="bold" color={colors.black} />
                    </HStack>
                  </Button>
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {dataFilter ? (
              dataFilter?.map((x, index) => (
                <Tr cursor="pointer" >
                  <Td>
                    <Text align="center">
                      {++index}
                    </Text>
                  </Td>
                  <Td>
                    <HStack spacing={3}>
                      <Box>
                        <Avatar size="md" name={x.photoProfile} src={x.photoProfile} />
                      </Box>
                      <Stack spacing={2} >
                        <Text>{x.name}</Text>
                        <Box>
                          {x.role === "admin" ? (<Tag bgColor="yellow" color="black">Admin</Tag>) : x.role === "member" ? (<Tag bgColor="green">Member</Tag>) : x.role === "user" ? <Tag bgColor="red">User</Tag> : ""}
                        </Box>
                        <Text size="md">Exp : {x.expired_user && new Date(x.expired_user).toLocaleString()}</Text>
                      </Stack>
                    </HStack>
                  </Td>
                  <Td>
                    <Stack>
                      <Text>{TextHelper(x.uid_user)}</Text>
                      <Text>{moment(x.update.seconds * 1000).toLocaleString()}</Text>
                    </Stack>
                  </Td>
                  <Td>
                    <Stack spacing={2}>
                      <Box>
                        {x.email}
                      </Box>
                      <Box>
                        {x.phoneNumber}
                      </Box>
                      <Box>
                        {x.city}
                      </Box>
                    </Stack>
                  </Td>
                  <Td color={colors.white}>
                    <IconButton onClick={() => EditDataComponent(x.uid_user)} m="2" aria-label="Edit database" colorScheme="yellow" icon={<EditIcon />} />
                    <IconButton onClick={() => handleDelete(x.uid_user)} m="2" aria-label="Delete database" colorScheme="red" icon={<DeleteIcon />} />
                  </Td>
                  <Td color={colors.white} >
                    <Flex justifyContent="space-around">
                      <Button onClick={() => whatsAppClickMessage(x.phoneNumber, x.name)} disabled={x.role === "member" || x.role === "admin"}>
                        <IoLogoWhatsapp size={30} color='#25D366' />
                      </Button>
                      <Select disabled={x.role === "member" || x.role === "admin"} width={100} onClick={fetchDataWahatsappTemplate} onChange={onSelectChangeTemplate} placeholder='Select option'>
                        {
                          whatsappDataTemplate.map(res =>
                            <option value={res.id}>{res.title}</option>
                          )
                        }
                      </Select>
                    </Flex>
                  </Td>
                </Tr>
              ))
            ) : (<></>)}
          </Tbody>
        </Table>
      </TableContainer>

    </Box>

  )
}

const ModalWhatsAppTemplate = ({ onOpen, onClose, isOpen }) => {

  const [createNew, setCreateNew] = useState(defaultTemplate)
  const [editTemplate, setEditTemplate] = useState(defaultTemplate)
  const [dataTemplate, setDataTemplate] = useState([])
  const [loading, setLoading] = useState(false)
  const onCloseModal = () => {
    setEditTemplate(defaultTemplate)
    setCreateNew(defaultTemplate)
    onClose()
  }





  const handlerTemplateContent = (e) => {

    setCreateNew({
      ...createNew,
      template: e.target.value
    })
  }

  const handlerTemplateTitle = (e) => {
    setCreateNew({
      ...createNew,
      title: e.target.value
    })
  }

  const handlerTemplateEditTitle = (e) => {

    setEditTemplate({
      ...editTemplate,
      title: e.target.value
    })
  }

  const handlerTemplateEditContent = (e) => {
    setEditTemplate({
      ...editTemplate,
      template: e.target.value
    })
  }

  const handlerSaveTemplate = (e) => {
    setLoading(true)
    auth.onAuthStateChanged(state => {
      addDoc(collection(db, "templatewhatsapp"), {
        ...createNew,
        template: encodeURI(createNew.template),
        createdBy: state.email,
        date: new Date()
      }).then(res => setLoading(false)).catch(err => setLoading(false))
    })

  }

  const fetchDataTemplate = () => {
    const q = query(collection(db, "templatewhatsapp"), limit(100));
    getDocs(q).then(res => {
      const dataTemp = []
      res.forEach(item => {
        dataTemp.push({ ...item.data(), id: item.id })
      })
      setDataTemplate(dataTemp)
    }).catch(e => console.log(e))
  }

  const handlerSelectOnchange = (e) => {
    const filter = dataTemplate.find(res => res.id === e.target.value)
    if (filter === undefined) {
      setEditTemplate(defaultTemplate)
    } else {
      auth.onAuthStateChanged(state => {
        setEditTemplate({
          ...filter,
          template: decodeURI(filter.template),
          createdBy: state.email,
          date: new Date()
        })
      })
    }
  }

  const handlerEditTemplate = async () => {
    setLoading(true)
    const docRef = doc(db, 'templatewhatsapp', editTemplate.id);
    setDoc(docRef, {
      ...editTemplate,
      template: encodeURI(editTemplate.template),
    }).then(res => setLoading(false)).catch(e => setLoading(false))


  }



  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>WhatsApp Template</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Tabs>
              <TabList>
                <Tab>Cretea New Template</Tab>
                <Tab>Edit Template</Tab>
              </TabList>

              <TabPanels>
                <TabPanel>
                  <FormControl>
                    <FormLabel>Name Template</FormLabel>
                    <Input type='text' onChange={handlerTemplateTitle} value={createNew.title} placeholder='Message For Admin' />
                    <FormHelperText>adding name for this template</FormHelperText>
                    <FormLabel>Template Chat</FormLabel>
                    <Textarea type='text' height={300} onChange={handlerTemplateContent} value={createNew.template} placeholder='hi ${name} We are sending you this message because you are the chosen one.' />
                    <FormHelperText>add $&#123;name&#125; in template to make it dynamically</FormHelperText>
                  </FormControl>
                  <Button disabled={createNew.title.length === 0 || createNew.template.length === 0 || loading} mr={"auto"} ml={"auto"} mt={5} colorScheme='teal' variant='solid' onClick={handlerSaveTemplate}>Save
                    {
                      loading &&

                      <Spinner marginLeft={2} accessibilityLabel="Loading..." color="white" />

                    }
                  </Button>
                </TabPanel>
                <TabPanel>
                  <FormControl>
                    <FormLabel>Select Template</FormLabel>
                    <Select onClick={fetchDataTemplate} onChange={handlerSelectOnchange} placeholder='Select option'>
                      {
                        dataTemplate.map(res =>
                          <option value={res.id}>{res.title}</option>
                        )
                      }
                    </Select>
                    <FormHelperText>Select the template</FormHelperText>
                    <FormLabel>Name Template</FormLabel>
                    <Input type='text' onChange={handlerTemplateEditTitle} disabled={editTemplate.title.length === 0} value={editTemplate.title} placeholder='Message For Admin' />
                    <FormHelperText>adding name for this template</FormHelperText>
                    <FormLabel>Template Chat</FormLabel>
                    <Textarea type='text' height={300} onChange={handlerTemplateEditContent} disabled={editTemplate.template.length === 0} value={editTemplate.template} placeholder='hi ${name} We are sending you this message because you are the chosen one.' />
                    <FormHelperText>add $&#123;name&#125; in template to make it dynamically</FormHelperText>
                  </FormControl>
                  <Button mr={"auto"} ml={"auto"} mt={5} colorScheme='teal' variant='solid' disabled={editTemplate.title.length === 0 && editTemplate.template.length === 0} onClick={handlerEditTemplate}>Save
                    {
                      loading &&

                      <Spinner marginLeft={2} accessibilityLabel="Loading..." color="white" />

                    }
                  </Button>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onCloseModal}>
              Close
            </Button>

          </ModalFooter>
        </ModalContent>
      </Modal>
    </>

  )
}

export default TableUser